module.exports = __webpack_public_path__ + "static/media/media1.2083bd08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/others/media1.png
// module id = 1228
// module chunks = 0